import { Patient } from 'src/app/data/patient/domain/patient';

export class PatientModel {
  id: string;
  firstName: string;
  lastName: string;
  initials: string;
  pictureUrl: string | undefined;
  updatedAt: Date | undefined;
  archivedAt: Date | undefined;
  checked: boolean;

  constructor(
    id: string,
    firstName: string,
    lastName: string,
    initials: string,
    pictureUrl: string | undefined,
    updatedAt: Date | undefined,
    archivedAt: Date | undefined,
    checked?: boolean,
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.initials = initials;
    this.pictureUrl = pictureUrl;
    this.updatedAt = updatedAt;
    this.archivedAt = archivedAt;
    this.checked = checked === true;
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  get reversedFullName(): string {
    return `${this.lastName} ${this.firstName}`;
  }

  get archived(): boolean {
    return this.archivedAt != undefined;
  }

  static fromPatient(patient: Patient, checked?: boolean) {
    return new PatientModel(
      patient.id.toString(),
      patient.firstName,
      patient.lastName,
      patient.initials,
      patient.avatarUrl,
      patient.updatedAt,
      patient.archivedAt,
      checked,
    );
  }

  static sort(a: PatientModel, b: PatientModel) {
    if (a.checked != b.checked) {
      return a.checked ? -1 : 1;
    }
    return a.reversedFullName.localeCompare(b.reversedFullName);
  }
}
